/*基本信息*/
<template>
  <div class="baseInfo">
    <div class="editTxt" @click="edit" v-if="!params.mode">编辑</div>
    <!-- 详情显示 -->
    <div class="info" v-if="data.infoList.length > 0">
      <a-descriptions layout="vertical">
        <a-descriptions-item
          :label="item.label"
          :labelStyle="data.labelStyle"
          :contentStyle="data.contentStyle"
          v-for="(item, index) in data.infoList"
          :key="index"
          class="children"
        >
          <div v-for="(sItem, sIndex) in item.children" :key="sIndex">
            <span v-if="item.type == 8">
              <span
                v-if="
                  (sItem.key == 'marriage' && [0, 1, 2, 3, 4].includes(data.baseInfo.marriage)) ||
                  (sItem.key == 'pregnant' && [1, 2, 3, 4].includes(data.baseInfo.pregnant)) ||
                  (sItem.key == 'gender' && [0, 1].includes(data.baseInfo.gender))
                "
              >
                <!-- 只显示性别为女并且有值 -->
                <span
                  v-if="
                    data.baseInfo.gender == 0 &&
                    data.baseInfo.marriage !== -1 &&
                    data.baseInfo.pregnant &&
                    sIndex == 1
                  "
                >
                  ，
                </span>
                <span>{{ labelTxt(sItem.key, sItem.value, 1, data.baseInfo.gender) }}</span>
              </span>
              <span v-else><span v-if="sIndex == 0">--</span></span>
            </span>
            <span v-else-if="item.type == 7">
              <span v-if="sItem && sItem.value && sItem.value.length > 0">
                <span v-for="(item, index) in sItem.value" :key="index">
                  <span v-if="sItem.value.length > 1 && index == 1">，</span>
                  {{ item }}
                </span>
              </span>
              <span v-else>--</span>
            </span>
            <span v-else>
              <template v-if="sItem.key === 'patientName'">
                <PatientNameAgeReveal
                  v-if="sItem.value"
                  :name="sItem.value"
                  :age="data.baseInfo.age"
                />
                <span v-else>--</span>
              </template>
              <template v-else>{{ sItem.value ? sItem.value : '--' }}</template>
            </span>
            <span v-if="sItem.value && item.u">{{ item.u }}</span>
          </div>
        </a-descriptions-item>
      </a-descriptions>
    </div>
    <!-- 编辑 -->
    <a-drawer
      title="基本信息"
      :width="726"
      :visible="data.visible"
      :body-style="{ paddingBottom: '80px' }"
      :closable="false"
    >
      <a-form ref="formRef" :model="data.form" layout="vertical">
        <a-row :gutter="16" type="flex" justify="space-between" align="bottom" style="margin: 0">
          <a-col
            v-for="(formItem, formIndex) in infoList"
            :key="formIndex"
            :span="formIndex == 2 ? '24' : '12'"
            :style="formIndex == 2 ? data.borderBottomStyle : ''"
          >
            <a-row :gutter="16" type="flex" justify="space-between" align="bottom">
              <div v-for="(sItem, sIndex) in formItem.children" :key="sIndex">
                <a-form-item :name="sItem.key">
                  <template v-slot:label>
                    <span class="formTitle">
                      {{ sIndex == 0 ? (formItem.label ? formItem.label : sItem.label) : '' }}
                    </span>
                  </template>
                  <div class="z-fixed">
                    <a-input
                      :placeholder="sItem.disabled ? '--' : '输入' + sItem.label"
                      v-if="[4].includes(formItem.type)"
                      v-model:value="data.form[sItem.key]"
                      class="formClass"
                      :maxlength="30"
                      @input="inputR($event, sItem.key, 1)"
                      :disabled="sItem.disabled"
                      allowClear
                    />
                    <a-input-number
                      :placeholder="sItem.disabled ? '--' : '输入' + sItem.label"
                      v-if="[1, 2].includes(formItem.type)"
                      v-model:value="data.form[sItem.key]"
                      class="formClass"
                      :maxlength="3"
                      @blur="inputR($event, sItem.key, 3)"
                      :disabled="sItem.disabled"
                    />
                    <a-cascader
                      placeholder="选择地区"
                      v-if="[7].includes(formItem.type)"
                      v-model:value="data.form[sItem.key]"
                      :options="data.citys"
                      :fieldNames="data.fieldNames"
                      :disabled="sItem.disabled"
                      allowClear
                      @change="handleAreaClick"
                    />
                    <div v-if="[8].includes(formItem.type) && sItem.isShow">
                      <a-select
                        :placeholder="sItem.disabled ? '--' : '请选择' + sItem.label"
                        :class="sItem.key === 'gender' ? 'formClass' : 'formClass-select'"
                        v-model:value="data.form[sItem.key]"
                        :disabled="sItem.disabled"
                        allowClear
                      >
                        <a-select-option
                          v-for="(oItem, oIndex) in data[sItem.key]"
                          :value="oItem.value"
                          :key="oIndex"
                        >
                          {{ oItem.label }}
                        </a-select-option>
                      </a-select>
                    </div>

                    <span class="selSpan">{{ formItem.u }}</span>
                  </div>
                </a-form-item>
              </div>
            </a-row>
          </a-col>
        </a-row>
      </a-form>

      <div :style="data.modelBtm">
        <!-- style="margin-right: 8px" -->
        <a-button class="cancelBtmClass" @click="onClose">取消</a-button>
        <a-button type="primary" @click="onSubmit">保存</a-button>
      </div>
    </a-drawer>
  </div>
</template>
<script setup>
import { reactive, onMounted, ref, toRaw, createVNode, defineProps } from 'vue'
import { infoList, formItemType } from './hooks/useComponent'
import { Modal, message } from 'ant-design-vue'
import { ExclamationCircleOutlined } from '@ant-design/icons-vue'
// , saveInfo
import { getCitys, getHealthInfo, saveInfo, getPatientInfo } from '@/api/HealthRecord/index.js'
import { inputRule } from '@/utils/validate'
import PatientNameAgeReveal from '@/components/PatientNameAgeReveal.vue'
const formRef = ref()
// pregnant 孕育情况：1未怀孕，2备孕中，3怀孕中，4哺乳中
// marriage：婚姻情况：0未婚，1已婚,2丧偶,3离异,4其他
const props = defineProps({
  params: {
    type: Object,
    default: () => ({
      ucPatientId: null,
      mode: ''
    })
  }
})
const data = reactive({
  ucPatientId: props.params.ucPatientId, //患者id
  form: {},
  rules: {},
  gender: [
    {
      value: '0',
      label: '女'
    },
    {
      value: '1',
      label: '男'
    }
    // {
    //   value: '2',
    //   label: '其他'
    // }
  ],
  marriage: [
    {
      value: '0',
      label: '未婚'
    },
    {
      value: '1',
      label: '已婚'
    },
    {
      value: '2',
      label: '丧偶'
    },
    {
      value: '3',
      label: '离异'
    },
    {
      value: '4',
      label: '其他'
    }
  ],
  pregnant: [
    {
      value: '1',
      label: '未怀孕'
    },
    {
      value: '2',
      label: '备孕中'
    },
    {
      value: '3',
      label: '怀孕中'
    },
    {
      value: '4',
      label: '哺乳中'
    }
  ],
  citys: [],
  cityId: null,
  fieldNames: { label: 'name', value: 'name', children: 'childs' },
  infoList: [],
  modelBtm: {
    position: 'absolute',
    right: 0,
    bottom: 0,
    width: '100%',
    borderTop: '1px solid #e9e9e9',
    padding: '10px 16px',
    background: '#fff',
    textAlign: 'right',
    zIndex: 1
  },
  borderBottomStyle: {
    borderBottom: '1px solid #E8E8E8',
    marginBottom: '15px'
  },
  labelStyle: {
    fontSize: '14px',
    color: '#999999',
    fontWeight: 'bold'
  },
  contentStyle: {
    fontSize: '14px',
    color: '#333333',
    fontWeight: 'bold',
    border: '1px solid rgba(217, 217, 217, 0.3)',
    padding: '8px'
  },
  visible: false,
  baseInfo: ''
})

// 目前版本没有用到校验，防止后期会加校验
const addRules = () => {
  return new Promise(resolve => {
    const ruleObj = reactive({})
    // let key = ''
    data.infoList.map(item => {
      item.children.map(cItem => {
        const rule = {
          required: item.require,
          message: [6, 8].includes(item.type) ? '请选择' + cItem.label : '请输入' + cItem.label,
          type: formItemType[item.type - 1].type,
          trigger: ['change', 'blur'],
          default: formItemType[item.type - 1].default
        }
        return (ruleObj[cItem.key] = rule)
      })
    })
    data.rules = ruleObj
    resolve()
  })
}
const save = () => {
  // 如果有值就传值给后端，如果没有值就传默认值
  const params = JSON.parse(JSON.stringify(data.form))
  params.patientName = params.patientName ? params.patientName : ''
  params.gender =
    params.gender && [0, 1].includes(Number(params.gender)) ? Number(params.gender) : 2
  params.age = params.age ? params.age : 0
  params.region = params.region && params.region.length > 0 ? params.region.join(',') : ''
  params.marriage =
    params.marriage && [0, 1, 2, 3, 4].includes(Number(params.marriage))
      ? Number(params.marriage)
      : -1
  params.pregnant =
    params.pregnant && [1, 2, 3, 4].includes(Number(params.pregnant)) ? Number(params.pregnant) : 0

  params.weight = params.weight && params.weight > 0 ? params.weight : 0
  params.height = params.height && params.height > 0 ? params.height : 0
  params.cityId = data.cityId ? data.cityId : 0
  params.type = 1
  saveInfo(params).then(() => {
    message.success('保存成功')
    data.infoList = []
    getBaseInfo()
  })
}

// 选择地区的时候 把id取到，后台需要
const handleAreaClick = (e, options) => {
  if (options && options.length > 0) {
    data.cityId = options[options.length - 1].id
  } else {
    data.cityId = null
  }
}
const onSubmit = () => {
  addRules().then(() => {
    formRef.value
      .validate()
      .then(() => {
        save()
        data.visible = false
      })
      .catch(error => {
        console.log('error', error, toRaw(toRaw(data.form)))
      })
  })
}

const labelTxt = (key, value, flg, gender) => {
  if (key + '' === 'pregnant') {
    value = Number(value) - 1
  }
  const n = flg ? data[key][parseInt(value)] : data[key][parseInt(value - 1)]
  if (gender && key + '' === 'pregnant') {
    return ''
  } else {
    return n ? n.label : ''
  }
}
const edit = () => {
  data.visible = true
  getBaseInfo()
}
const onClose = () => {
  Modal.confirm({
    centered: true,
    icon: createVNode(ExclamationCircleOutlined),
    title: () => '取消后无法保存，确定取消吗？',
    okText: () => '确定',
    cancelText: () => '取消',
    onOk() {
      data.visible = false
    },
    onCancel() {}
  })
}

const getCts = () => {
  getCitys().then(res => {
    //处理只获取两级
    if (res && res.length > 0) {
      res.map(pItem => {
        pItem.childs.map(cItem => {
          cItem.childs = null
        })
      })
      data.citys = res
    }
  })
}
const getHealth = () => {
  //主要是获取健康信息的id
  getHealthInfo({ ucPatientId: data.ucPatientId }).then(res => {
    if (res) {
      // res.id有就返id给后端，如果没有就不返，当id没有的时候，id字段都不能传给后端（后端要求）
      if (res.id) {
        data.form.id = res.id
      }
    }
  })
}
const getBaseInfo = () => {
  getPatientInfo({ ucPatientId: data.ucPatientId })
    .then(res => {
      if (res) {
        if (res.cityId) {
          data.cityId = res.cityId
        }
        data.baseInfo = res
        data.form.ucPatientId = data.ucPatientId
        infoList.map(item => {
          item.children.map(cItem => {
            cItem.value = res[cItem.key]
            // 初始化from
            //说明是有值得
            if (cItem.key + '' === 'pregnant') {
              // 如果是男就不显示，其他情况为显示
              if (res.gender == 1) {
                cItem.isShow = false
              } else {
                cItem.isShow = true
              }
            }
            if (
              res[cItem.key] ||
              (cItem.key + '' === 'gender' && res[cItem.key] === 0) ||
              (cItem.key + '' === 'marriage' && res[cItem.key] === 0)
            ) {
              data.form[cItem.key] = res[cItem.key]
              if (item.type === 8) {
                data.form[cItem.key] = res[cItem.key] + ''
                // 后端会有一个type为2的时候是其他，但是前端只有0：女 1：男
                if (cItem.key + '' === 'gender') {
                  //处理后端返的性别值>1的时候值为默认的空值
                  if (res[cItem.key] > 1) {
                    data.form[cItem.key] = formItemType[item.type - 1].default
                  }
                }
                if (cItem.key + '' === 'marriage') {
                  if (res[cItem.key] < 0) {
                    data.form[cItem.key] = formItemType[item.type - 1].default
                  }
                }
              } else if (item.type === 7) {
                //type == 7说明是地区，后端返的字段为逗号隔开的字符串，处理成前端需要的数组
                cItem.value = res[cItem.key].split(',')
                data.form[cItem.key] = res[cItem.key].split(',')
              }
            } else {
              data.form[cItem.key] = formItemType[item.type - 1].default
            }
          })
        })
      }
      data.infoList = infoList
      addRules()
    })
    .then(() => {
      getHealth()
    })
}
const inputR = (e, key, type) => {
  data.form[key] = inputRule(e.target.value, type)
}
onMounted(() => {
  getBaseInfo()
  //获取城市列表
  getCts()
})
</script>
<style scoped lang="scss">
.selSpan {
  margin-left: 4px;
}
.cancelBtmClass {
  margin-right: 8px;
}
// .formTitle {
//   font-weight: 400;
//   font-size: 12px;
//   color: #999999;
// }
.formClass {
  width: 180px;
}
.formClass-select {
  width: 157px;
  margin-right: 8px;
}
::v-deep(.ant-cascader-picker) {
  max-width: 180px;
  min-width: 180px;
}
.baseInfo {
  position: relative;
  padding: 0 20px;

  .info {
    padding-top: 15.5px;
    // display: grid;
    // grid-template-columns: repeat(3, 1fr);
    ::v-deep(.ant-descriptions-item-label::after) {
      content: '';
    }
    ::v-deep(.ant-descriptions-item-container) {
      width: 234px;
    }
  }
  .editTxt {
    height: 32px;
    line-height: 32px;
    text-align: right;
    border-bottom: 1px solid #e8e8e8;
    color: #1890ff;
    cursor: pointer;
  }
}
</style>
